import React, { useEffect, useRef, useState } from "react";
import { Card } from "antd";
import Form from "../components/form";
import {
  broad_specialty_defs,
  narrow_specialty_defs,
} from "../../../../../constant/specialty";
import { naicsSectors } from "../../../../../constant/naics-sectors";
import { supplyChainPositionDef } from "../../../../../constant/supply-chain";
import { toast } from "react-toastify";
import { validateAndNormalizeURL } from "../../../../../utils";
import http from "../../../../../services/http";
import { useSelector } from "react-redux";
import {
  getGoalQuestionValue,
  hasGoalQuestionValue,
} from "../helpers/goal-question-value";
import {
  insertGoalQuestionInOrder,
  upsertGoalQuestionInOrder,
} from "../helpers/goal-question-order";

const Questionaire = ({
  title,
  questions,
  currentStep,
  sets = {},
  dataSet,
  state = [],
  setState,
  populateLoader,
  populateFieldsLoader,
  populateHelper,
  populateOptionsTrigger = 0,
  goalInputs = {},
}) => {
  // STATES
  const [broadOptions, setBroadptions] = useState([]);
  const [narrowOptions, setnarrowOptions] = useState([]);
  const [supplyChainOptions, setsupplyChainOptions] = useState([]);
  const [naicsSectorOptions, setnaicsSectorOptions] = useState([]);
  const [acquireFiveOptions, setAcquireFiveOptions] = useState([]);
  const [acquireSixOptions, setAcquireSixOptions] = useState([]);
  const [acquireEightOptions, setAcquireEightOptions] = useState([]);
  const [descriptionLoader, setDescriptionLoader] = useState(false);
  const industryDraftHydratedRef = useRef(false);

  // REDUX DATA
  const { selected_company: selectedCompany } = useSelector(
    (state) => state.CompanyReducer,
  );

  // HELPERS
  const populateDescriptionHelper = (url, index) => {
    if (!url) {
      toast.error("Please provide URL to populate the description.");
      return;
    }
    const { url: newUrl, isValid } = validateAndNormalizeURL(url);
    if (url && !isValid) {
      toast.error("Please provide a valid URL.");
      return;
    }
    setDescriptionLoader(true);
    http
      .post(`populate-company-description/${selectedCompany.id}`, {
        url: newUrl || "",
      })
      .then(({ data }) => {
        toast.success(`Description populated successfully`);
        changeValue(index, data.description || "", "description_input");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error || `Error populating description`);
      })
      .finally(() => {
        setDescriptionLoader(false);
      });
  };

  const removeFieldValueAndOptionsHelper = (newData, field, options) => {
    let value = [...newData.find((f) => f.key === field.key).value];
    newData.find((f) => f.key === field.key).value = value.filter((val) =>
      options.some((x) => x.value === val),
    );
    return newData;
  };

  const setFieldOptionOnChangeHelper = (label, value) => {
    let item = questions.filter((g) => g.label === label)[0];
    let val =
      typeof value === "object"
        ? item?.max_selection
          ? value.slice(0, item?.max_selection)
          : value
        : [value];

    if (label === "primary_sector_input") {
      let newData = [...state];
      const broadOptionsList = [];
      const supplyChainOptionsList = [];
      const narrowOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          if (broad_specialty_defs[key]) {
            broadOptionsList.push({ label: key, value: key, indicator: true });
            broad_specialty_defs[key].forEach((item) => {
              broadOptionsList.push({
                label: item,
                value: item,
              });
            });
          }
          if (supplyChainPositionDef[key]) {
            supplyChainOptionsList.push({ label: key, value: key, indicator: true });
            supplyChainPositionDef[key].forEach((item) => {
              supplyChainOptionsList.push({
                label: item,
                value: item,
              });
            });
          }
        });
      }
      setBroadptions(broadOptionsList);
      setsupplyChainOptions(supplyChainOptionsList);

      // update broad specialty input
      const broadField = state.find((field) => field.key === "broad_specialty_input");
      newData = removeFieldValueAndOptionsHelper(newData, broadField, broadOptionsList);

      // update supply chain input
      const supplyChainField = state.find(
        (field) => field.key === "supply_chain_dropdown",
      );
      newData = removeFieldValueAndOptionsHelper(
        newData,
        supplyChainField,
        supplyChainOptionsList,
      );

      const broadFieldValue =
        newData.find((field) => field.key === "broad_specialty_input")?.value || [];
      broadFieldValue.forEach((item) => {
        if (narrow_specialty_defs[item]) {
          narrowOptionsList.push({ label: item, value: item, indicator: true });
          narrow_specialty_defs[item].forEach((narrowItem) => {
            narrowOptionsList.push({
              label: narrowItem,
              value: narrowItem,
            });
          });
        }
      });
      setnarrowOptions(narrowOptionsList);
      newData = removeFieldValueAndOptionsHelper(
        newData,
        state.find((field) => field.key === "narrow_specialty_input"),
        narrowOptionsList,
      );

      setState({ ...sets, [title]: newData });
    }
    if (label === "broad_specialty_input") {
      const narrowOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          if (narrow_specialty_defs[key]) {
            narrowOptionsList.push({ label: key, value: key, indicator: true });
            narrow_specialty_defs[key].forEach((item) => {
              narrowOptionsList.push({
                label: item,
                value: item,
              });
            });
          }
        });
      }
      setnarrowOptions(narrowOptionsList);
      let newData = [...state];
      const removeAbleFields = state.filter(
        (field) => field.key === "narrow_specialty_input",
      );
      removeAbleFields.forEach((field) => {
        const options = narrowOptionsList;
        let value = [...newData.find((f) => f.key === field.key).value];
        newData.find((f) => f.key === field.key).value = value.filter((val) =>
          options.some((x) => x.value === val),
        );
      });
      setState({ ...sets, [title]: newData });
    }
    if (label === "NAICS-Master-Dropdown") {
      const sectorsOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          const selectedOption = item?.options?.find((o) => o.value === key);
          let options = naicsSectors.filter(
            (sector) =>
              sector.label.slice(0, 2) === String(selectedOption.label) &&
              sector.label.length >= 6,
          );
          if (
            typeof selectedOption.label === "string" &&
            selectedOption.label.includes("-")
          ) {
            const parts = selectedOption.label.split("-");
            const start = parseInt(parts[0], 10);
            const end = parseInt(parts[1], 10);

            const numbers = [];
            for (let i = start; i <= end; i++) {
              numbers.push(i.toString());
            }
            options = naicsSectors.filter(
              (sector) =>
                numbers.includes(sector.label.slice(0, 2)) && sector.label.length >= 6,
            );
          }
          sectorsOptionsList.push({
            label: selectedOption.label,
            value: selectedOption.value,
            indicator: true,
          });
          options.forEach((sector) => {
            sectorsOptionsList.push({
              label: sector.label,
              value: sector.value,
            });
          });
        });
      }
      const uniqueOptions = Array.from(
        new Set(sectorsOptionsList.map((option) => option.value)),
      ).map((value) => {
        return sectorsOptionsList.find((option) => option.value === value);
      });
      setnaicsSectorOptions(uniqueOptions);
    }
    if (label === "acquire-four") {
      const broadOptionsList = [];
      const narrowOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          if (broad_specialty_defs[key]) {
            broadOptionsList.push({ label: key, value: key, indicator: true });
            broad_specialty_defs[key].forEach((item) => {
              broadOptionsList.push({
                label: item,
                value: item,
              });
            });
          }
        });
      }
      setAcquireFiveOptions(broadOptionsList);

      const broadFieldValue =
        state.find((field) => field.key === "acquire-five")?.value || [];
      broadFieldValue.forEach((item) => {
        if (narrow_specialty_defs[item]) {
          narrowOptionsList.push({ label: item, value: item, indicator: true });
          narrow_specialty_defs[item].forEach((narrowItem) => {
            narrowOptionsList.push({
              label: narrowItem,
              value: narrowItem,
            });
          });
        }
      });
      setAcquireSixOptions(narrowOptionsList);

      let newData = [...state];
      const removeAbleFields = state.filter(
        (field) => field.key === "acquire-five" || field.key === "acquire-six",
      );
      removeAbleFields.forEach((field) => {
        const options =
          field.key === "acquire-five" ? broadOptionsList : narrowOptionsList;
        let value = [...newData.find((f) => f.key === field.key).value];
        newData.find((f) => f.key === field.key).value = value.filter((val) =>
          options.some((x) => x.value === val),
        );
      });
      setState({ ...sets, [title]: newData });
    }
    if (label === "acquire-five") {
      const narrowOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          if (narrow_specialty_defs[key]) {
            narrowOptionsList.push({ label: key, value: key, indicator: true });
            narrow_specialty_defs[key].forEach((item) => {
              narrowOptionsList.push({
                label: item,
                value: item,
              });
            });
          }
        });
      }
      setAcquireSixOptions(narrowOptionsList);
      let newData = [...state];
      const removeAbleFields = state.filter((field) => field.key === "acquire-six");
      removeAbleFields.forEach((field) => {
        const options = narrowOptionsList;
        let value = [...newData.find((f) => f.key === field.key).value];
        newData.find((f) => f.key === field.key).value = value.filter((val) =>
          options.some((x) => x.value === val),
        );
      });
      setState({ ...sets, [title]: newData });
    }
    if (label === "acquire-seven") {
      const sectorsOptionsList = [];
      if (val && typeof val === "object") {
        val.forEach((key) => {
          const selectedOption = item?.options?.find((o) => o.value === key);
          let options = naicsSectors.filter(
            (sector) =>
              sector.label.slice(0, 2) === String(selectedOption.label) &&
              sector.label.length >= 6,
          );
          if (
            typeof selectedOption.label === "string" &&
            selectedOption.label.includes("-")
          ) {
            const parts = selectedOption.label.split("-");
            const start = parseInt(parts[0], 10);
            const end = parseInt(parts[1], 10);

            const numbers = [];
            for (let i = start; i <= end; i++) {
              numbers.push(i.toString());
            }
            options = naicsSectors.filter(
              (sector) =>
                numbers.includes(sector.label.slice(0, 2)) && sector.label.length >= 6,
            );
          }
          sectorsOptionsList.push({
            label: selectedOption.label,
            value: selectedOption.value,
            indicator: true,
          });
          options.forEach((sector) => {
            sectorsOptionsList.push({
              label: sector.label,
              value: sector.value,
            });
          });
        });
      }
      const uniqueOptions = Array.from(
        new Set(sectorsOptionsList.map((option) => option.value)),
      ).map((value) => {
        return sectorsOptionsList.find((option) => option.value === value);
      });
      setAcquireEightOptions(uniqueOptions);
    }
  };

  const setFieldOptionsHelper = () => {
    const data = [...state];
    const broadOptionsList = [];
    const supplyChainOptionsList = [];
    const narrowOptionsList = [];
    const sectorsOptionsList = [];
    const acquireFiveOptionsList = [];
    const acquireSixOptionsList = [];
    const acquireEightOptionsList = [];

    const primarySectorField = data.find((field) => field.key === "primary_sector_input");
    const primarySectorValue = primarySectorField?.value;
    const primarySectorArray = Array.isArray(primarySectorValue)
      ? primarySectorValue
      : primarySectorValue != null && primarySectorValue !== ""
        ? [primarySectorValue]
        : [];
    if (primarySectorArray.length > 0) {
      primarySectorArray.forEach((key) => {
        if (broad_specialty_defs[key]) {
          broadOptionsList.push({ label: key, value: key, indicator: true });
          broad_specialty_defs[key].forEach((item) => {
            broadOptionsList.push({
              label: item,
              value: item,
            });
          });
        }
        if (supplyChainPositionDef[key]) {
          supplyChainOptionsList.push({ label: key, value: key, indicator: true });
          supplyChainPositionDef[key].forEach((item) => {
            supplyChainOptionsList.push({
              label: item,
              value: item,
            });
          });
        }
      });
    }
    setBroadptions(broadOptionsList);
    setsupplyChainOptions(supplyChainOptionsList);

    const broadFieldRaw =
      data.find((field) => field.key === "broad_specialty_input")?.value ?? [];
    const broadFieldValue = Array.isArray(broadFieldRaw)
      ? broadFieldRaw
      : broadFieldRaw !== "" && broadFieldRaw != null
        ? [broadFieldRaw]
        : [];
    broadFieldValue.forEach((item) => {
      if (narrow_specialty_defs[item]) {
        narrowOptionsList.push({ label: item, value: item, indicator: true });
        narrow_specialty_defs[item].forEach((narrowItem) => {
          narrowOptionsList.push({
            label: narrowItem,
            value: narrowItem,
          });
        });
      }
    });
    setnarrowOptions(narrowOptionsList);

    const naicsField = data.find((field) => field.key === "NAICS-Master-Dropdown");
    if (naicsField && naicsField.value) {
      const naicsValueArray = Array.isArray(naicsField.value)
        ? naicsField.value
        : [naicsField.value];
      naicsValueArray.forEach((key) => {
        const selectedOption = naicsField.options?.find((o) => o.value === key);
        if (!selectedOption) return;
        let options = naicsSectors.filter(
          (sector) =>
            sector.label.slice(0, 2) === String(selectedOption.label) &&
            sector.label.length >= 6,
        );
        if (
          typeof selectedOption.label === "string" &&
          selectedOption.label.includes("-")
        ) {
          const parts = selectedOption.label.split("-");
          const start = parseInt(parts[0], 10);
          const end = parseInt(parts[1], 10);

          const numbers = [];
          for (let i = start; i <= end; i++) {
            numbers.push(i.toString());
          }
          options = naicsSectors.filter(
            (sector) =>
              numbers.includes(sector.label.slice(0, 2)) && sector.label.length >= 6,
          );
        }
        sectorsOptionsList.push({
          label: selectedOption.label,
          value: selectedOption.value,
          indicator: true,
        });
        options.forEach((sector) => {
          sectorsOptionsList.push({
            label: sector.label,
            value: sector.value,
          });
        });
      });
    }
    const uniqueOptions = Array.from(
      new Set(sectorsOptionsList.map((option) => option.value)),
    ).map((value) => {
      return sectorsOptionsList.find((option) => option.value === value);
    });
    setnaicsSectorOptions(uniqueOptions);

    const acquireFourField = data.find((field) => field.key === "acquire-four");
    if (acquireFourField && acquireFourField.value) {
      if (broad_specialty_defs[acquireFourField.value]) {
        acquireFiveOptionsList.push({
          label: acquireFourField.value,
          value: acquireFourField.value,
          indicator: true,
        });
        broad_specialty_defs[acquireFourField.value].forEach((item) => {
          acquireFiveOptionsList.push({
            label: item,
            value: item,
          });
        });
      }
      setAcquireFiveOptions(acquireFiveOptionsList);
    }

    const acquireFiveField = data.find((field) => field.key === "acquire-five");
    if (acquireFiveField && acquireFiveField.value) {
      acquireFiveField.value.forEach((key) => {
        if (narrow_specialty_defs[key]) {
          acquireSixOptionsList.push({ label: key, value: key, indicator: true });
          narrow_specialty_defs[key].forEach((item) => {
            acquireSixOptionsList.push({
              label: item,
              value: item,
            });
          });
        }
      });
      setAcquireSixOptions(acquireSixOptionsList);
    }
    const acquireSevenField = data.find((field) => field.key === "acquire-seven");
    if (acquireSevenField && acquireSevenField.value) {
      acquireSevenField.value.forEach((key) => {
        const selectedOption = acquireSevenField.options.find((o) => o.value === key);
        let options = naicsSectors.filter(
          (sector) =>
            sector.label.slice(0, 2) === String(selectedOption.label) &&
            sector.label.length >= 6,
        );
        if (
          typeof selectedOption.label === "string" &&
          selectedOption.label.includes("-")
        ) {
          const parts = selectedOption.label.split("-");
          const start = parseInt(parts[0], 10);
          const end = parseInt(parts[1], 10);

          const numbers = [];
          for (let i = start; i <= end; i++) {
            numbers.push(i.toString());
          }
          options = naicsSectors.filter(
            (sector) =>
              numbers.includes(sector.label.slice(0, 2)) && sector.label.length >= 6,
          );
        }
        acquireEightOptionsList.push({
          label: selectedOption.label,
          value: selectedOption.value,
          indicator: true,
        });
        options.forEach((sector) => {
          acquireEightOptionsList.push({
            label: sector.label,
            value: sector.value,
          });
        });
      });
      const uniqueOptions = Array.from(
        new Set(acquireEightOptionsList.map((option) => option.value)),
      ).map((value) => {
        return acquireEightOptionsList.find((option) => option.value === value);
      });
      setAcquireEightOptions(uniqueOptions);
    }
  };

  // Reset a question's value to its schema default (empty string, [], or range min).
  const resetQuestionValue = (q) => {
    if (q.type === "range" && Array.isArray(q.range)) return q.range[0] ?? 1;
    if (q.type === "multi_select" || q.type === "input_tag") return [];
    if (typeof q.value === "number") return 0;
    return "";
  };

  const hasQuestionValue = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "number") return true;
    return Boolean(value);
  };

  const handleChange = (index, label, option) => {
    let data = state;
    const question = questions.filter((g) => g.label === label)[0];
    data[index].value = option.value;
    // if (isGoals && data.length >= index + 1) {
    //   for (let i = index + 1; i < data.length; i++) {
    //     if (data[i].type === "range") {
    //       data[i].value = 1;
    //     } else {
    //       data[i].value = typeof data[i].value === "object" ? [] : "";
    //     }
    //   }
    // }
    let optionQuestions = [];
    let targetQuestions = [];
    if (option.label && typeof option.label === "object") {
      optionQuestions = questions.filter((g) => option.label.includes(g.label));
    } else {
      optionQuestions = questions.filter((g) => g.label === option.label);
      if (option.label.includes("remove@")) {
        const removeLabel = option.label.replace("remove@", "");
        data = data.filter((q) => q.label !== removeLabel);
      }
    }
    if (question?.target?.length) {
      question.target.forEach((t) => {
        if (t.value === "all") {
          const newQuestion = questions.filter((g) => g.label === t.label)[0];
          if (newQuestion && !data.some((x) => x.label === newQuestion.label)) {
            targetQuestions.push(newQuestion);
          }
        }
      });
    }
    let filteredQuestions = [...data];

    if (label === "question-one") {
      filteredQuestions = data.filter((q) => q.parent.includes(label) === false);
    }

    filteredQuestions = filteredQuestions.filter(
      (dq) =>
        !optionQuestions.some((oq) => oq.label === dq.label) &&
        !targetQuestions.some((tq) => tq.label === dq.label),
    );

    optionQuestions = optionQuestions.filter(
      (oq) => !filteredQuestions.some((fq) => fq.label === oq.label),
    );

    targetQuestions = targetQuestions.filter(
      (tq) => !filteredQuestions.some((fq) => fq.label === tq.label),
    );

    if (!label.includes("acquire")) {
      data = [...filteredQuestions];
    }

    if (label === "question-one" && option.value === "Acquire") {
      const newQuestions = questions.filter((nq) => nq.key.includes("acquire"));
      data = [...filteredQuestions, ...newQuestions];
    }
    const isAcquireTree =
      data.find((q) => q.key === "question-one")?.value === "Acquire";
    // Acquire shows the full branch at once; other trees use progressive option.label chaining.
    if (!isAcquireTree) {
      const currentQuestionIndex = filteredQuestions.findIndex((q) => q.label === label);

      if (currentQuestionIndex === -1) {
        data = [...filteredQuestions, ...optionQuestions, ...targetQuestions];
      } else {
        data = [
          ...filteredQuestions.slice(0, currentQuestionIndex + 1),
          ...optionQuestions,
          ...filteredQuestions.slice(currentQuestionIndex + 1),
          ...targetQuestions,
        ];
      }
    }
    // On question-one change, reset all other questions in the new tree to defaults.
    if (label === "question-one") {
      data = data.map((q) =>
        q.label === "question-one"
          ? { ...q, value: option.value }
          : { ...q, value: resetQuestionValue(q) },
      );
    }
    setFieldOptionOnChangeHelper(label, option.value);

    setState({ ...sets, [title]: data });
  };

  const changeValue = (index, value, label) => {
    let item = questions.filter((g) => g.label === label)[0];
    let val = item?.max_selection ? value.slice(0, item?.max_selection) : value;

    setFieldOptionOnChangeHelper(label, value);

    let data = state;
    data[index].value = val;

    if (item && item?.max_selection) {
      if (Array.isArray(val) && val.length > item?.max_selection) {
        data[index].value = val.slice(0, item?.max_selection);
      }
    }
    // if (isGoals && data.length >= index + 1) {
    //   for (let i = index + 1; i < data.length; i++) {
    //     if (data[i].type === "range") {
    //       data[i].value = 1;
    //     } else {
    //       data[i].value = typeof data[i].value === "object" ? [] : "";
    //     }
    //   }
    // }
    // if (data.length >= index + 2) {
    //   data[index + 1].value = "";
    // }
    // if (data.length >= index + 3) {
    //   data[index + 2].value = "";
    // }
    // if (data.length >= index + 4) {
    //   data[index + 3].value = "";
    // }
    if (item) {
      if ("target" in item && Array.isArray(item.target)) {
        const targetsToAdd = [];
        item.target.forEach((t) => {
          const shouldShow =
            t.value === "all" ||
            (Array.isArray(val) && val.some((x) => String(x).toLowerCase() === t.value));
          if (shouldShow) {
            const targetQuestion = questions.filter((g) => g.label === t.label)[0];
            if (targetQuestion && !data.some((x) => x.label === targetQuestion.label)) {
              targetsToAdd.push(targetQuestion);
            }
          }
        });
        if (targetsToAdd.length) {
          data = targetsToAdd.reduce(
            (list, targetQuestion) =>
              title === "goals"
                ? insertGoalQuestionInOrder(list, targetQuestion, questions)
                : [...list, targetQuestion],
            data,
          );
        }
        // else {
        //   if (data.length >= index + 2) {
        //     data[index + 1].value = "";
        //   }
        //   if (data.length >= index + 3) {
        //     data[index + 2].value = "";
        //   }
        //   if (data.length >= index + 4) {
        //     data[index + 3].value = "";
        //   }
        //   data = [...filteredQuestions];
        // }
      }
    }

    setState({ ...sets, [title]: data });
  };

  // Rebuild options when state changes or when parent applied status API data (populateOptionsTrigger)
  useEffect(() => {
    setFieldOptionsHelper();
  }, [state, populateOptionsTrigger]);

  // Show Florence optional questions only after the branch-specific trigger question is filled in.
  useEffect(() => {
    if (title !== "goals" || !Array.isArray(state)) return;
    const isAcquireTree = state.some(
      (q) => q.key === "question-one" && q.value === "Acquire",
    );
    const shouldShowIndustrySegmentation = state.some(
      (q) =>
        Array.isArray(q.target) &&
        q.target.some((target) => target.label === "industry_segmentation") &&
        hasQuestionValue(q.value),
    );
    const hasIndustrySegmentation = state.some((q) => q.key === "industry_segmentation");
    const industryQuestion = state.find((q) => q.key === "industry_segmentation");
    const industryTemplate = questions.find((q) => q.key === "industry_segmentation");
    const draftIndustryValue = industryTemplate
      ? getGoalQuestionValue(industryTemplate, goalInputs)
      : null;
    const hasDraftIndustryValue = hasGoalQuestionValue(draftIndustryValue);
    const shouldShowIndustry = isAcquireTree || shouldShowIndustrySegmentation;

    if (shouldShowIndustry && !hasIndustrySegmentation && industryTemplate) {
      const value = hasDraftIndustryValue ? draftIndustryValue : industryTemplate.value;
      setState({
        ...sets,
        [title]: insertGoalQuestionInOrder(
          state,
          { ...industryTemplate, value },
          questions,
        ),
      });
      return;
    }

    // Acquire tree injects industry from the API template (empty); patch with draft once on load only.
    if (
      shouldShowIndustry &&
      hasIndustrySegmentation &&
      hasDraftIndustryValue &&
      !hasQuestionValue(industryQuestion?.value) &&
      !industryDraftHydratedRef.current
    ) {
      industryDraftHydratedRef.current = true;
      setState({
        ...sets,
        [title]: upsertGoalQuestionInOrder(
          state,
          industryTemplate,
          questions,
          draftIndustryValue,
        ),
      });
      return;
    }

    if (!shouldShowIndustry && hasIndustrySegmentation && !hasQuestionValue(industryQuestion?.value)) {
      setState({
        ...sets,
        [title]: state.filter(
          (q) =>
            q.key !== "industry_segmentation" &&
            q.key !== "user_preferred_ranking_focus",
        ),
      });
    }
  }, [title, state, questions, sets, goalInputs]);

  // Show user_preferred_ranking_focus only when industry_segmentation is visible.
  useEffect(() => {
    if (title !== "goals" || !Array.isArray(state)) return;

    const hasIndustrySegmentation = state.some((q) => q.key === "industry_segmentation");
    const florenceIndex = state.findIndex(
      (q) => q.key === "user_preferred_ranking_focus",
    );

    const florenceTemplate = questions.find((q) => q.key === "user_preferred_ranking_focus");
    const florenceInState = state.find((q) => q.key === "user_preferred_ranking_focus");
    const draftFlorenceValue = florenceTemplate
      ? getGoalQuestionValue(florenceTemplate, goalInputs)
      : null;
    const hasDraftFlorenceValue = hasGoalQuestionValue(draftFlorenceValue);

    if (hasIndustrySegmentation && florenceIndex === -1 && florenceTemplate) {
      const nextValue = hasDraftFlorenceValue ? draftFlorenceValue : [];
      setState({
        ...sets,
        [title]: insertGoalQuestionInOrder(
          state,
          { ...florenceTemplate, value: nextValue },
          questions,
        ),
      });
      return;
    }

    if (!hasIndustrySegmentation && florenceIndex !== -1 && !hasQuestionValue(florenceInState?.value)) {
      setState({
        ...sets,
        [title]: state.filter((q) => q.key !== "user_preferred_ranking_focus"),
      });
    }
  }, [title, state, questions, sets, goalInputs]);

  return (
    <Card bordered={false} sx={{ width: "100%" }}>
      {state.map((question, index) => {
        if (!question.options && !question.type) return null;
        return (
          <Form
            key={`form-${index}`}
            index={index}
            data={question}
            title={title}
            sets={sets}
            form={state}
            setForm={setState}
            onChange={handleChange}
            onChangeInput={changeValue}
            broadOptions={broadOptions}
            narrowOptions={narrowOptions}
            supplyChainOptions={supplyChainOptions}
            naicsSectorOptions={naicsSectorOptions}
            acquireFiveOptions={acquireFiveOptions}
            acquireSixOptions={acquireSixOptions}
            acquireEightOptions={acquireEightOptions}
            populateHelper={populateHelper}
            populateLoader={populateLoader}
            populateFieldsLoader={populateFieldsLoader}
            descriptionLoader={descriptionLoader}
            populateDescriptionHelper={populateDescriptionHelper}
          />
        );
      })}
    </Card>
  );
};

export default Questionaire;
